export const REDIRECT_URL = __ANYDO_ENV_DEV__ ? "https://develop.anydo.dev/myday" : "https://app.any.do/myday";

export const GOOGLE_CLIENT_ID =
  __ANYDO_ENV_DEV__ ?
    "543675644531-u3crpgh3nks32rhtqbolhmrlj8uvcir6.apps.googleusercontent.com"
  : "543675644531-nsdamnj2uqafj8d3hv9q9lmevvc9tcrm.apps.googleusercontent.com";

export const GOOGLE_RECAPTCHA_SITE_KEY = "6Le0784oAAAAAKlcpM4NH00ZAnGJSrra5Cd-RTQc";

export const GTM_ID = __ANYDO_ENV_DEV__ ? "GTM-M34MJGRT" : "GTM-TLD6B96G";

export const BASE_URL = __ANYDO_ENV_DEV__ ? "https://sm-dev-teams.any.do" : "https://sm-prod4.any.do";

export const CHECK_EMAIL_URL = `${BASE_URL}/check_email`;
export const USER_URL = `${BASE_URL}/user`;
export const PRE_2FA_LOGIN_URL = `${BASE_URL}/login-2fa`;
export const LOGIN_2FA_URL = `${BASE_URL}/login-2fa-code`;
export const GOOGLE_LOGIN_URL = `${BASE_URL}/google-login`;

export const BOARD_TEMPLATE_DATA_KEY = "onboarding_templates/en__other__project.json";

const searchParams = typeof location !== "undefined" ? new URLSearchParams(location.search) : undefined;

export const SHOW_TRIAL_PLAN = searchParams?.has("trial") ?? false;

export const PLAN_PERIOD = searchParams?.get("period") ?? "yearly";

export const STATIC_YEARLY_PLAN_DATA = {
  // defaults

  whatsapp_yearly_36_trial: {
    period: "Year",
    trial: 7,
    price: 3599,
    currency: "USD",
  },

  whatsapp_yearly_36: {
    period: "Year",
    trial: 0,
    price: 3599,
    currency: "USD",
  },

  // country specific
  whatsapp_lp_yearly_no_trial_gb: {
    period: "Year",
    trial: 0,
    price: 2388,
    currency: "GBP",
  },
  whatsapp_lp_yearly_no_trial_in: {
    period: "Year",
    trial: 0,
    price: 138800,
    currency: "INR",
  },
  whatsapp_lp_yearly_no_trial_br: {
    period: "Year",
    trial: 0,
    price: 9588,
    currency: "BRL",
  },
  whatsapp_lp_yearly_no_trial_de: {
    period: "Year",
    trial: 0,
    price: 3347,
    currency: "EUR",
  },
  whatsapp_lp_yearly_no_trial_it: {
    period: "Year",
    trial: 0,
    price: 3347,
    currency: "EUR",
  },
  whatsapp_lp_yearly_no_trial_mx: {
    period: "Year",
    trial: 0,
    price: 31200,
    currency: "MXN",
  },
  whatsapp_lp_yearly_no_trial_es: {
    period: "Year",
    trial: 0,
    price: 3347,
    currency: "EUR",
  },
} as const;

export const STATIC_MONTHLY_PLAN_DATA = {
  // defaults

  whatsapp_monthly_36_trial: {
    period: "Month",
    trial: 7,
    price: 3599,
    currency: "USD",
  },

  whatsapp_lp_monthly_no_trial: {
    period: "Month",
    trial: 0,
    price: 599,
    currency: "USD",
  },

  // country specific
  whatsapp_lp_monthly_trial_gb: {
    period: "Month",
    trial: 7,
    price: 350,
    currency: "GBP",
  },
  whatsapp_lp_monthly_trial_in: {
    period: "Month",
    trial: 7,
    price: 19200,
    currency: "INR",
  },
  whatsapp_lp_monthly_trial_br: {
    period: "Month",
    trial: 7,
    price: 1299,
    currency: "BRL",
  },
  whatsapp_lp_monthly_trial_de: {
    period: "Month",
    trial: 7,
    price: 449,
    currency: "EUR",
  },
  whatsapp_lp_monthly_trial_it: {
    period: "Month",
    trial: 7,
    price: 449,
    currency: "EUR",
  },
  whatsapp_lp_monthly_trial_mx: {
    period: "Month",
    trial: 7,
    price: 4000,
    currency: "MXN",
  },
  whatsapp_lp_monthly_trial_es: {
    period: "Month",
    trial: 7,
    price: 449,
    currency: "EUR",
  },
  whatsapp_lp_monthly_no_trial_gb: {
    period: "Month",
    trial: 0,
    price: 350,
    currency: "GBP",
  },
  whatsapp_lp_monthly_no_trial_in: {
    period: "Month",
    trial: 0,
    price: 19200,
    currency: "INR",
  },
  whatsapp_lp_monthly_no_trial_br: {
    period: "Month",
    trial: 0,
    price: 1299,
    currency: "BRL",
  },
  whatsapp_lp_monthly_no_trial_de: {
    period: "Month",
    trial: 0,
    price: 449,
    currency: "EUR",
  },
  whatsapp_lp_monthly_no_trial_it: {
    period: "Month",
    trial: 0,
    price: 449,
    currency: "EUR",
  },
  whatsapp_lp_monthly_no_trial_mx: {
    period: "Month",
    trial: 0,
    price: 4000,
    currency: "MXN",
  },
  whatsapp_lp_monthly_no_trial_es: {
    period: "Month",
    trial: 0,
    price: 449,
    currency: "EUR",
  },
} as const;
